import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { FaUserPlus, FaSyncAlt, FaMoneyBillWave, FaTimesCircle } from "react-icons/fa";
import React, { useState, useEffect } from "react";
import axios from 'axios';
import Select from "react-select";
import { MdOutlinePersonOff } from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi";
import { RiPagesLine } from "react-icons/ri";
import { TbChartBarPopular } from "react-icons/tb";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import ConfirmDialog from "../../components/ToastNotification/ConfirmModal";
import { RiDeleteBin6Fill } from "react-icons/ri";
function SuscriptionHistory() {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [taskData, setTaskData] = useState([]);
  const [viewData, setViewData] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [serviceStaffMap, setServiceStaffMap] = useState({});
  const [selectedPlan, setSelectedPlan] = useState("");
  const plans = [...new Set(data.map(item => item.sub_name))];
  const planOptions = [{
    value: "",
    label: "All Plans"
  }, ...plans.map(plan => ({
    value: plan,
    label: plan
  }))];
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const showConfirmDialog = ({
    title,
    message,
    onConfirm
  }) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({
          ...confirmDialog,
          show: false
        });
      }
    });
  };
  const [preStaff, setPreStaff] = useState([]);
  const filtered = data.filter(item => {
    const matchSearch = item.user_name?.toLowerCase().includes(search.toLowerCase());
    const matchPlan = selectedPlan ? item.sub_name === selectedPlan : true;
    return matchSearch && matchPlan;
  });
  const today = new Date();
  const expiredCount = data.filter(item => {
    const end = new Date(item.end_date);
    const from = new Date(fromDate);
    const to = new Date(toDate);
    return end >= from && end <= to;
  }).length;
  const activeCount = data.filter(item => {
    return new Date(item.end_date) >= today;
  }).length;
  const totalUsers = new Set(data.map(item => item.user_id)).size;
  const totalPlans = new Set(data.map(item => item.sub_name)).size;
  let planCount = {};
  data.forEach(item => {
    if (item.sub_name) {
      planCount[item.sub_name] = (planCount[item.sub_name] || 0) + 1;
    }
  });

  // find max
  let mostDemandedPlan = "";
  let maxCount = 0;
  for (let plan in planCount) {
    if (planCount[plan] > maxCount) {
      maxCount = planCount[plan];
      mostDemandedPlan = plan;
    }
  }
  const fetchSubHistory = async () => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/fetch-subscription-history?from=${fromDate}&to=${toDate}`);
      setData(res.data);

      // console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const today = new Date();
    const todayStr = today.toISOString().split("T")[0];
    setFromDate(todayStr);
    const nextMonth = new Date(today);
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    const nextMonthStr = nextMonth.toISOString().split("T")[0];
    setToDate(nextMonthStr);
  }, []);
  useEffect(() => {
    if (fromDate && toDate) {
      fetchSubHistory();
    }
  }, [fromDate, toDate]);
  const formatDate = date => {
    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
  };
  const fetchAttendance = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-present-staff");
      const data = res.data;
      setPreStaff(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchTask = async subId => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/fetch-task/${subId}`);
      const data = res.data;
      setTaskData(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAttendance();
  }, []);
  const handleAllocateStaff = async () => {
    try {
      // if (!selectedRow || !selectedStaff) {
      //   alert("Please select staff");
      //   return;
      // }
      const payload = Object.entries(serviceStaffMap).map(([service_id, val]) => ({
        sub_history_id: selectedRow.id,
        service_id: Number(service_id),
        staff_id: val.staff_id,
        no_times: val.no_times,
        type: "default"
      }));
      await axios.post("https://api.sweepydo.in/assign-staff", payload);
      setShowModal(false);
      showToast("Staff assigned successfully", "success");
      fetchSubHistory();
    } catch (error) {
      console.log(error);
      showToast("Fail to assigned staff", "danger");
    }
  };
  const parseServices = serviceStr => {
    try {
      return JSON.parse(serviceStr || "[]");
    } catch {
      return [];
    }
  };
  const handleDelete = async id => {
    try {
      await axios.delete(`https://api.sweepydo.in/delet-subscription-history/${id}`);
      showToast("Work slot deleted successfully", 'success');
      fetchSubHistory();
    } catch (err) {
      console.error("Error deleting role:", err);
      showToast("Failed to delete work slot", 'danger');
    }
  };
  return <div className="container-fluid p-4">
 
      <h3 className="text-white mb-4 text-center">Subscription History</h3>

 <div className="d-flex flex-wrap gap-3 mb-4">


 <div style={{
        flex: "1 1 220px"
      }} className="col-md-3 mb-3">
    <div className="card p-4 shadow-lg  border border-secondary rounded-4 d-flex flex-row justify-content-between align-items-center text-white" style={{
          backgroundColor: "var(--black)",
          minHeight: "140px"
        }}>
      <div>
        <h6>Toal Subscription</h6>
        <h4>{totalPlans} </h4>
      
      </div>
      <div className="bg-primary text-white p-2 rounded-circle">
        <RiPagesLine size={25} />
      </div>
    </div>
  </div>

  <div style={{
        flex: "1 1 220px"
      }} className="col-md-3 mb-3">
    <div className="card p-4 shadow-lg  border border-secondary rounded-4 d-flex flex-row justify-content-between align-items-center text-white" style={{
          backgroundColor: "var(--black)",
          minHeight: "140px"
        }}>
      <div>
        <h6>Toal Subscriber</h6>
        <h4>{totalUsers} </h4>
      
      </div>
      <div className="bg-warning text-white p-2 rounded-circle">
        <HiOutlineUserGroup size={25} />
      </div>
    </div>
  </div>

  <div style={{
        flex: "1 1 220px"
      }} className="col-md-3 mb-3">

    <div className="card p-4 shadow-lg  border border-secondary rounded-4 d-flex flex-row justify-content-between align-items-center text-white" style={{
          backgroundColor: "var(--black)",
          minHeight: "140px"
        }}>
      <div>
        <h6>Upcoming Expiry</h6>
       <h4>{expiredCount}</h4>
    
      </div>
      <div className="bg-danger text-white p-2 rounded-circle">
        <MdOutlinePersonOff size={25} />
      </div>
    </div>
  </div>

  <div style={{
        flex: "1 1 220px"
      }} className="col-md-3 mb-3">
    <div className="card p-4 shadow-lg  border border-secondary rounded-4 d-flex flex-row justify-content-between align-items-center text-white" style={{
          backgroundColor: "var(--black)",
          minHeight: "140px"
        }}>
      <div>
        <h6>Active Subscription</h6>
       <h4>{activeCount}</h4>
      </div>
      <div className="bg-success text-white p-2 rounded-circle">
        <FaUserPlus size={24} />
      </div>
    </div>
  </div>

  <div style={{
        flex: "1 1 220px"
      }} className="col-md-3 mb-3">
    <div className="card p-4 shadow-lg  border border-secondary rounded-4 d-flex flex-row justify-content-between align-items-center text-white" style={{
          backgroundColor: "var(--black)",
          minHeight: "140px"
        }}>
      <div>
        <h6>Most Demanded Plan</h6>
      <h5>{mostDemandedPlan || "-"}</h5>
      {/* <small>{maxCount} Users</small> */}
      </div>
      <div className="bg-info text-white p-2 rounded-circle">
        <TbChartBarPopular size={24} />
      </div>
    </div>
  </div>

</div>


      <div className="card border-0 shadow" style={{
      background: "var(--black)",
      borderRadius: "12px"
    }}>
        
     

<div className="d-flex justify-content-between align-items-center flex-wrap p-3 gap-3 mb-3">


  <div style={{
          minWidth: "250px"
        }}>
    <input type="text" className="form-control p-3" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} style={{
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />
  </div>

  {/* RIGHT SIDE → Filters */}
  <div className="d-flex align-items-center gap-3 flex-wrap">

    {/* From Date */}
    <input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} style={{
            width: "180px",
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />

    {/* To Date */}
    <input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} style={{
            width: "180px",
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />

    {/* Plan Filter */}
    <div style={{
            width: "220px"
          }}>
      <Select options={planOptions} value={planOptions.find(opt => opt.value === selectedPlan)} onChange={selected => setSelectedPlan(selected?.value || "")} placeholder="Filter by Plan" isClearable styles={{
              control: base => ({
                ...base,
                backgroundColor: "#0f172a",
                borderColor: "#334155",
                color: "#fff",
                minHeight: "45px",
                boxShadow: "none"
              }),
              menu: base => ({
                ...base,
                backgroundColor: "#1e293b",
                color: "#fff"
              }),
              singleValue: base => ({
                ...base,
                color: "#fff"
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused ? "#334155" : "#1e293b",
                color: "#fff"
              }),
              placeholder: base => ({
                ...base,
                color: "#94a3b8"
              }),
              input: base => ({
                ...base,
                color: "#fff"
              })
            }} />
    </div>

  </div>
</div>

        {/* Table */}
        <div className="table-responsive">
          <table className="table table-hover  align-middle text-white mb-0 text-center" style={{
          backgroundColor: "var(--black)",
          color: "#fff"
        }}>
            <thead style={{
            background: "#0f172a"
          }}>
              <tr>
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>NAME</th>
              
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>BUY ON</th>
                   <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>END ON</th>
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>STATUS</th>
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}> PLAN</th>
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>ACTIONS</th>
          
              </tr>
            </thead>

       <tbody>
  {filtered.map((item, i) => <tr key={i} style={{
              borderBottom: "1px solid #334155",
              padding: '20px'
            }}>

      {/* Name */}
      <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
        {item.user_name}
      </td>

      <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
        {formatDate(item.rec_date)}
      </td>

       <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
        {formatDate(item.end_date)}
      </td>


      <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
        <span className={item.status === "Success" ? "badge bg-success " : "badge bg-secondary"}>
          {item.status}
        </span>
      </td>

   
      <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
        <span className="badge bg-warning text-dark">
          {item.sub_name}
        </span>
      </td>

<td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>



  {item.is_allot === 1 ? <>
      <span className="badge bg-success me-2">Allocated</span>

      <button className="btn btn-sm btn-info" onClick={async () => {
                    await fetchTask(item.id);

                    // console.log(taskData);
                    // const matched = taskData.find(
                    //   (t) => t.sub_history_id === item.id
                    // );
                    setSelectedRow(item);
                    setViewData(taskData);
                    setShowViewModal(true);
                  }}>
        View
      </button>
    </> : <button className="btn btn-sm btn-primary" onClick={() => {
                  setSelectedRow(item);
                  const services = parseServices(item.service_name);
                  const initialMap = {};
                  services.forEach(s => {
                    initialMap[s.sId] = {
                      staff_id: "",
                      no_times: s.no_times
                    };
                  });
                  setServiceStaffMap(initialMap);
                  console.log(item);
                  setShowModal(true);
                }}>
      Assign
    </button>}


  {item.status === "Pending" && <RiDeleteBin6Fill size={20} cursor="pointer" title="Delete" className="mx-2 text-danger" onClick={() => showConfirmDialog({
                  title: "Delete work slot",
                  message: "Are you sure you want to delete this plan?",
                  onConfirm: () => handleDelete(item.id)
                })} />}


</td>

    </tr>)}
</tbody>
          </table>
        </div>


  {showModal && <div className="modal fade show" style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.6)"
      }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content" style={{
            backgroundColor: "var(--black)",
            color: "#fff",
            border: "1px solid #2d3748"
          }}>

        
        <div className="modal-header border-0">
          <h5 className="modal-title">Assign Staff</h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
        </div>

    
<div className="modal-body">

  {selectedRow && parseServices(selectedRow.service_name).map((service, index) => <div key={index} className="mb-3 p-2 rounded" style={{
                border: "1px solid #333"
              }}>
        {/* Service Name */}
        <div className="mb-2">
          <strong>{service.name}</strong>
          <small className="ms-2">
            ({service.s_type} service | {service.no_times} Time{service.no_times > 1 ? "s" : ""})
          </small>
        </div>

        {/* Staff Select */}
        <select className="form-select" value={serviceStaffMap[service.sId]?.staff_id || ""} onChange={e => setServiceStaffMap(prev => ({
                  ...prev,
                  [service.sId]: {
                    ...prev[service.sId],
                    staff_id: e.target.value
                  }
                }))} style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff",
                  border: "1px solid #444"
                }}>
          <option value="">Select Staff</option>

          {preStaff.map(staff => <option key={staff.staff_id} value={staff.staff_id}>
              {staff.staff_name}
            </option>)}
        </select>
      </div>)}
</div>
        <div className="modal-footer border-0">
          <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
            Cancel
          </button>

          <button className="btn btn-primary" onClick={handleAllocateStaff}>
            Save
          </button>
        </div>

      </div>
    </div>
  </div>}


{showViewModal && viewData && <div className="modal fade show" style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.6)"
      }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content bg-dark text-white">

        <div className="modal-header">
          <h5>Assigned Staff Details</h5>
          <button className="btn-close btn-close-white" onClick={() => setShowViewModal(false)}></button>
        </div>
{selectedRow && taskData.length > 0 && <div className="p-2">
    {taskData.map((task, i) => <div key={i} className="p-2 mb-2 rounded" style={{
                border: "1px solid #333"
              }}>
        {/* Service Name (direct lookup inline) */}
        <strong>
          {parseServices(selectedRow.service_name).find(s => s.sId === task.service_id)?.name || "Unknown Service"} - Shift {task.times}
        </strong>

        <div className="mt-1">
          👤 {task.staff_name} ({task.staff_mobile})
        </div>

        <small className="text-warning fw-semibold">
          Alloted On: {formatDate(task.allocated_on)}
        </small>
      </div>)}
  </div>}


      </div>
    </div>
  </div>}
      </div>

       <ConfirmDialog show={confirmDialog.show} title={confirmDialog.title} message={confirmDialog.message} onConfirm={confirmDialog.onConfirm} onCancel={() => setConfirmDialog({
      ...confirmDialog,
      show: false
    })} />
    </div>;
}
export default SuscriptionHistory;
